import type { AxiosError, AxiosResponse } from "axios";
import type { EditChatMessageInput, EditedMessageResponse } from "shared";
import { inlineEmailStyles } from "shared/features/chat/utils/inlineEmailStyles";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_CHAT_BASE_URL;

export const editChatMessage = async ({
  serviceType,
  serviceId,
  chatId,
  message,
}: EditChatMessageInput): Promise<EditedMessageResponse> => {
  try {
    const url = `${BASE_URL}/api/messages/v2/${serviceType}/${serviceId}/messages/${chatId}`;
    const response = await axiosClient.patch(url, { message: inlineEmailStyles(message) });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw response;
  } catch (error) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};
